import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { goBack } from 'react-router-redux';

import { AscendState } from '../../ducks';
import { ADD_DEBT } from '../../ducks/actions';
import { Debt } from '../../models/debt';
import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import AddDebtForm from './AddDebtForm/AddDebtForm';

interface AddDebtProps {
  sendingDebt: boolean;
  addDebt: (debtInfo: Debt) => void;
  back: () => void;
}

const parseDebt = (debtInfo: any) => {
  if (debtInfo.apr) {
    debtInfo.apr = debtInfo.apr * 0.01;
  }
  // debtInfo.paidThisMonth = Number(debtInfo.paidThisMonth) || 0;
  const dueDate = debtInfo.paymentDueDate;
  if (dueDate) {
    debtInfo.paymentDueDate =
      typeof dueDate === 'string'
        ? dueDate
        : new Date(dueDate.getTime() - dueDate.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0];
  }

  return debtInfo;
};

const AddDebt = ({ sendingDebt, back, addDebt }: AddDebtProps) => (
  <Layout>
    <div>
      <Title text="Add Debt" />
      <AddDebtForm
        sendingDebt={sendingDebt}
        back={() => back()}
        onSubmit={(debtInfo: Debt) => {
          const parsedDebt = parseDebt(debtInfo);
          return addDebt(parsedDebt);
        }}
      />
    </div>
  </Layout>
);

const mapStateToProps = (state: AscendState) => ({
  sendingDebt: state.debt.loading,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  addDebt: (debt: Debt) => dispatch({ type: ADD_DEBT, debt }),
  back: () => dispatch(goBack()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDebt);
